// extracted by mini-css-extract-plugin
export default {"editJobContainer":"EditJob_editJobContainer__BUi1z","headerText":"EditJob_headerText__Ee8rf","header":"EditJob_header__4EzIl","sectionContainer":"EditJob_sectionContainer__2JL4q"};